<template>
  <div>

    <!-- toasts message -->
    <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <insertForm :formSchema="formSchema" v-on:emitForm="close"></insertForm>

    <v-card-title>
      <h2>Sub Project Information</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
				<!-- <td class="text-xs-left">{{ props.item.project_name_short }}</td> -->
        <td class="text-xs-left">{{ props.item.sub_project_name }}</td>
				<td class="text-xs-left">{{ props.item.sectorName }}</td>
       <!--  <td class="text-xs-left">{{ changeFormateDMY(props.item.project_start_date) }}</td>
				<td class="text-xs-left">{{ changeFormateDMY(props.item.project_end_date) }}</td> -->
        <td class="text-xs-left">{{ props.item.client_name }}</td>
				<td class="text-xs-left">{{ props.item.moratorium_period }}</td>
        <td class="text-xs-left">{{ props.item.location_name }}</td>
        <td class="text-xs-left">{{ props.item.usd_total | currency }}</td>
        <td class="text-xs-left">{{ props.item.bdt_total | currency }}</td>
        
				<!-- <td class="text-xs-left">{{ props.item.agreement_date }}</td>
				<td class="text-xs-left">{{ props.item.comments }}</td>
				<td class="text-xs-left">{{ props.item.gob_usd }}</td>
				<td class="text-xs-left">{{ props.item.ida_usd }}</td>
				<td class="text-xs-left">{{ props.item.usd_total }}</td>
				<td class="text-xs-left">{{ props.item.gob_bdt }}</td>
				<td class="text-xs-left">{{ props.item.ida_bdt }}</td>
				<td class="text-xs-left">{{ props.item.bdt_total }}</td> -->
				
         
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import insertForm from "./insertForm";
import Axios from "axios";

export default {
  components: {
    insertForm
  },

  data: () => ({
    valid: true,

    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
              {
                text: "SL",
                value: ""
              },
              /*{
                text: "Project Name", align: "left", sortable: true, value: "project_name_short"
              },*/
              {
                text: "Sub Project Name", align: "left", sortable: true, value: "sub_project_name"
              },
              {
                text: "Sector Name", align: "left", sortable: true, value: "sectorName"
              },
              {
                text: "Client Name", align: "left", sortable: true, value: "client_name"
              },
              /*{
                text: "Sub Project Start Date", align: "left", sortable: true, value: "project_start_date"
              },
              {
                text: "Sub Project End Date", align: "left", sortable: true, value: "project_end_date"
              },*/
              {
                text: "Moratorium Period(Month)", align: "left", sortable: true, value: "moratorium_period"
              },
              {
                text: "Location", align: "left", sortable: true, value: "location_name"
              },
              {
                text: "Total USD Sanction Amount", align: "left", sortable: true, value: "usd_total"
              },
              {
                text: "Total BDT Sanction Amount", align: "left", sortable: true, value: "bdt_total"
              },
              

              { text: "Action", align: "center", value: "" }
    ],
    /*------------- /Datatable ---------------*/

    delete_id: "",
    row_index: "",
    dialog2: false,

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id : 0,
      sub_project_name: "",
      project_start_date: "",
      project_end_date: "",
      agreement_date: "",
      moratorium_period: "",
      comments: "",
      gob_usd: "",
      ida_usd: "",
      usd_total: "",
      gob_bdt: "",
      ida_bdt: "",
      bdt_total: "",
				
    }
  }),

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    }
  },
  /*------------/Datatable------------*/

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService.getServerSideData(query_Data, "sub-project-info-list").then(res => {
            if(res.status == 0)
            {             
              this.SnackbarVal.color = "success"; 
              this.SnackbarVal.message = res.message;
              this.SnackbarVal.snackbar = true;
            }
            
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = { ...item }; 
      
      this.formSchema.project_start_date = this.changeFormateDMY(
				item.project_start_date
			);
			this.formSchema.project_end_date = this.changeFormateDMY(
				item.project_end_date
			);
			this.formSchema.agreement_date = this.changeFormateDMY(
				item.agreement_date
			);
			
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },    

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      this.SnackbarVal.color = "error"; 

      commonService.deleteRow(id, "sub-project-info").then(res => {
        if (res.status == 1) {
          this.SnackbarVal.color = "success"; 
          this.desserts.splice(row_index, 1);
          this.getDataFromApi();
        }
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close(res) {
     
      if (res.status == 1) {
        if (res.action == "add") {
          this.desserts.unshift({ ...res.data });
        }
        if (res.action == "edit") {
          this.$set(this.desserts, this.row_index, { ...res.data });
          this.row_index = "";
        }
        window.scrollTo({
          left: 0,
          top:
            document.body.scrollHeight || document.documentElement.scrollHeight,
            behavior: "smooth"
        });
      }            
      else 
      {
        this.formSchema.project_start_date = this.changeFormateDMY(
				item.project_start_date
			);
			this.formSchema.project_end_date = this.changeFormateDMY(
				item.project_end_date
			);
			this.formSchema.agreement_date = this.changeFormateDMY(
				item.agreement_date
			);
			
      }      

      this.SnackbarVal.color = "success"; 
      this.SnackbarVal.message = res.message;
      this.SnackbarVal.snackbar = true;

    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/lending/subProjectInfo/dataTable.vue